
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';

import {
    DialogConfirm,
    IfComp,
    SelectAttributes,
    SelectAttributeValue,
    utils
} from '../../../core';

const FetchAttributeList = ({
    attributes,
    attributeVisibility,
    dataModelItem,
    geom,
    onChangeAttributes,
    onChangeAttributeVisibility,
    onChangeGeom,
    onFetch
}) => {

    const classNames = mergeStyleSets({
        FetchAttributeList: {
            paddingRight: 8
        },
        content: {
            overflowY: 'auto',
            height: 0
        },
        buttons: {
            paddingBottom: 8
        }
    });

    const doChangeAttributes = (attrs) => {
        if (onChangeAttributes) {
            onChangeAttributes(attrs);
        }
    }

    const doChangeGeom = (geom) => {
        if (onChangeGeom) {
            onChangeGeom(geom);
        }
    }

    const doFetch = async (mode) => {

        const processedValues = processValues();

        const canFetch = ((Object.keys(processedValues).length === 0) && !geom)
            ? await DialogConfirm.show(
                `Nejsou zadané žádné omezující podmínky pro načtení objektů.<br>` +
                `Opravdu chcete načíst všechny objekty typu "${dataModelItem.title}" ?`
            )
            : true;

        if (canFetch && onFetch) {
            onFetch(mode, processedValues, geom);
        }
    }

    function getDefaultAttributes() {
        let allowAttributes = get(dataModelItem, 'operations.get.allowAttributes');

        let attributes = dataModelItem.attributes.reduce((previous, current) => {
            if (isAttributeAllow(current, allowAttributes)) {
                previous.push(current);
            }
            return previous;
        }, []);
        return attributes;
    }

    function getSelectedAttributes() {
        const attrs = attributeVisibility || getDefaultAttributes().map(item => item.name);
        return dataModelItem.attributes.filter(item => {
            return (attrs.indexOf(item.name) !== -1);
        });
    }

    const handleClear = () => {
        doChangeAttributes({});
        doChangeGeom(null);
    }

    const handleFetch = () => {
        doFetch('SET');
    }

    const handleSelectAttribute = (values) => {
        onChangeAttributeVisibility(values);
    }

    const handleSetValue = (value, name) => {
        doChangeAttributes({
            ...attributes,
            [name]: value
        });
    }

    const isAttributeAllow = (attribute, allowAttributes) => {
        let allow = (attribute.hidden !== true);
        if (allowAttributes) {
            allow = allow && (allowAttributes.indexOf(attribute.name) !== -1);
        }
        return allow
    }

    const processValues = () => {
        return Object.keys(attributes).reduce((previous, current) => {
            if (attributes[current]) {
                previous[current] = attributes[current];
            }
            return previous;
        }, {});
    }

    const getSelectAttributeValueOptions = () => {
        let options = cloneDeep(utils.styles.SELECT_ATTR_VALUE_STYLES_OPTIONS);
        set(options, 'ComboBox.emptyValue', {key: '', text: '<<vše>>'})
        return options;
    }

    return (
        <Stack verticalFill className={classNames.FetchAttributeList} tokens={{childrenGap: 16}} >
            <Stack.Item>
                <SelectAttributes
                    attributes={dataModelItem.attributes.map(item => {
                        return {...item, id: item.name};
                    })}
                    onChange={handleSelectAttribute}
                    options={utils.styles.SELECT_ATTR_VALUE_STYLES_OPTIONS}
                    readOnly={false}
                    values={getSelectedAttributes().map(item => item.name)}
                />
            </Stack.Item>
            <Stack.Item grow className={classNames.content}>
                {getSelectedAttributes().map(item => {
                    return (
                        <SelectAttributeValue
                            attribute={{...item, id: item.name}}
                            key={item.name}
                            onChange={handleSetValue}
                            options={getSelectAttributeValueOptions()}
                            title={item.title}
                            value={attributes[item.name]}
                        />
                    );
                })}
            </Stack.Item>
            <Stack.Item>
                <IfComp cond={geom}>
                    <Stack horizontal>
                        <FontIcon iconName="LocationDot" />
                        <Stack.Item>polygon je zadaný</Stack.Item>
                    </Stack>
                </IfComp>
            </Stack.Item>
            <Stack.Item className={classNames.buttons}>
                <Stack horizontal horizontalAlign="end" tokens={{childrenGap: 8}}>
                    <DefaultButton text="Vyčistit" onClick={handleClear} />
                    <PrimaryButton
                        onClick={handleFetch}
                        text="Načíst objekty"
                        split
                        menuProps={{
                            items: [{
                                key: 'ADD',
                                text: 'Načíst objekty a přidat',
                                onClick: () => doFetch('ADD')
                            }, {
                                key: 'REMOVE',
                                text: 'Načíst objekty a odebrat',
                                onClick: () => doFetch('REMOVE')
                            }, {
                                key: 'FILTER',
                                text: 'Načíst objekty a filtrovat',
                                onClick: () => doFetch('FILTER')
                            }]
                        }}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default FetchAttributeList;
